import { baseURL } from "config/api";

const normalizeAbsoluteUrl = (url?: string) => {
  const value = String(url || "").trim();
  if (!value) return "";

  try {
    return new URL(value).toString();
  } catch {
    return value;
  }
};

export const resolveUploadAssetUrl = (raw?: string) => {
  const value = String(raw || "").trim();
  if (!value) return "";

  const apiRoot = String(baseURL || "").replace(/\/api\/?$/i, "").replace(/\/+$/g, "");

  if (/^https?:\/\//i.test(value)) {
    return normalizeAbsoluteUrl(value);
  }

  const cleanPath = value.replace(/^\/+/g, "");
  if (cleanPath.startsWith("Upload/")) {
    return `${apiRoot}/${cleanPath}`;
  }

  return `${apiRoot}/Upload/${cleanPath}`;
};

export const cacheBustUrl = (url?: string, version?: string | number) => {
  const resolvedUrl = String(url || "").trim();
  if (!resolvedUrl) return "";

  const joiner = resolvedUrl.includes("?") ? "&" : "?";
  return `${resolvedUrl}${joiner}v=${encodeURIComponent(String(version || Date.now()))}`;
};

export const resolveCacheBustedUploadAssetUrl = (
  raw?: string,
  version?: string | number
) => cacheBustUrl(resolveUploadAssetUrl(raw), version);
